module.exports = __webpack_public_path__ + "img/second_img.9009eddd.png";